import { css } from '@emotion/css';
import { SingleSelect } from 'Shared/forms/Inputs'
import { LabelOnLeftWrap } from 'Shared/forms/Wrap'
import type {OverlayLayout} from 'Shared/model/Components';
import { detailsStyle } from 'Shared/backend/widgets/Section';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { createEffect, createSignal, Show } from 'solid-js';
import { optionList } from 'Shared/backend/widgets/ComponentOptions';
import { Amount, defaultAmountUnits } from 'Shared/forms/Amount';
import { sizes } from 'Shared/backend/Theme';
import { VerticalConstraint } from 'Shared/backend/widgets/VerticalConstraint';
import { IntegratedSelectorAndComponent } from 'Shared/backend/widgets/IntegratedSelectorAndComponent';
import { useLayout } from '../LayoutProvider';


export function OverlayComponent(P:OverlayLayout)
{
	const fluidDefaults = {pageMin:sizes().endFontShrink,minValue:300,pageMax:sizes().minDesktopWidth,maxValue:500};
	const sw = useStore();
	const lo = useLayout();

	const backgroundOptions = optionList(['image','slides','styles'],['popup']);
	const foregroundOptions = optionList(['text','vertical','image','styles'],['popup']);

	const [showBackground,setShowBackground] = createSignal(true);
	const [showForeground,setShowForeground] = createSignal(true);

	return (
		<div class={detailsStyle()}>
			<Show when={lo.layout()}>
				<StoreProvider {...sw} location={[...sw.location,'height']}>
					<VerticalConstraint {...P.height} label='Height' options={['parent','child','ratio','height']} />
				</StoreProvider>
			</Show>

			<IntegratedSelectorAndComponent {...P.background} label='Background' contentFieldName='background' options={backgroundOptions} required 
				expanded={showBackground} setExpanded={setShowBackground}
			/>

			<IntegratedSelectorAndComponent {...P.foreground} label='Foreground' contentFieldName='foreground' options={foregroundOptions} required 
				expanded={showForeground} setExpanded={setShowForeground}
			/>

			<Show when={lo.layout()}>
				<h4>Foreground settings</h4>

				<StoreProvider {...sw} location={[...sw.location,'vertical']}>
					<Alignment {...P.vertical} label='Vertical alignment' options={{center:'Center',top:'From top',bottom:'From bottom'}} required />
				</StoreProvider>

				<StoreProvider {...sw} location={[...sw.location,'horizontal']}>
					<Alignment {...P.horizontal} label='Horizontal alignment' options={{center:'Center',left:'From left',right:'From right'}} required />
				</StoreProvider>

				<StoreProvider {...sw} location={[...sw.location,'foregroundHeight']}>
					<VerticalConstraint {...P.foregroundHeight} label='Foreground height' options={['child','parent','height']} />
				</StoreProvider>

				<LabelOnLeftWrap label='Width'>
					<Amount field='width' options={{...defaultAmountUnits,full:'full'}} fluidDefaults={fluidDefaults} />
				</LabelOnLeftWrap>
			</Show>
		</div>
	);
}

function Alignment(P)
{
	const offsetStyle = css({
		marginLeft: '5em'
	});

	const fluidDefaults = {pageMin:sizes().endFontShrink,minValue:50,pageMax:sizes().minDesktopWidth,maxValue:100};

	return (<>
		<LabelOnLeftWrap label={P.label}>
			<SingleSelect field='side' required={true} options={P.options} />
		</LabelOnLeftWrap>

		<Show when={P.side!='center'} fallback={<div/>}>
			<div class={offsetStyle}>
				<LabelOnLeftWrap label='Offset' disable={P.side=='center'}>
					<Amount field='offset' options={defaultAmountUnits} disable={P.side=='center'} fluidDefaults={fluidDefaults}  />
				</LabelOnLeftWrap>
			</div>
		</Show>
	</>);
}

